import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { MbscModule } from '../lib/mobiscroll/js/mobiscroll.angular.min.js';

import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

// Style guide page specific
import { StyleGuideComponent } from './style-guide/style-guide.component';

// Bookings page specific
import { CreateBookingComponent } from './bookings/create-booking/create-booking.component';
// import { CreateBookingComponent as CreateBookingNewComponent} from './bookings-new/create-booking/create-booking.component';
import { CreateBookingService } from './bookings/create-booking/create-booking.service';
import { MyBookingsService } from './bookings/my-bookings/my-bookings.service';
import { MyBookingsComponent } from './bookings/my-bookings/my-bookings.component';
import { RequestorFormComponent } from './bookings/create-booking/user-details/requestor-form/requestor-form.component';
// import { RequestorFormComponent as RequestorFormNewComponent} from './bookings-new/create-booking/user-details/requestor-form/requestor-form.component';
import { RidersTableComponent } from './bookings/create-booking/user-details/riders-table/riders-table.component';
// import { RidersTableComponent as RidersTableNewComponent} from './bookings-new/create-booking/user-details/riders-table/riders-table.component';
import { UserDetailsComponent } from './bookings/create-booking/user-details/user-details.component';
// import { UserDetailsComponent as UserDetailsNewComponent} from './bookings-new/create-booking/user-details/user-details.component';
import { ConfirmRequestComponent } from './bookings/create-booking/confirm-request/confirm-request.component';
// import { ConfirmRequestComponent as ConfirmRequestNewComponent} from './bookings-new/create-booking/confirm-request/confirm-request.component';
import { TripDetailsComponent } from './bookings/create-booking/trip-details/trip-details.component';
// import { TripDetailsComponent as TripDetailsNewComponent} from './bookings-new/create-booking/trip-details/trip-details.component';

// Core components
import { HeaderComponent } from './core/header/header.component';
import { SidebarLinkComponent } from './core/sidebar-link/sidebar-link.component';

// Shared components
import { ButtonComponent } from './shared/components/button/button.component';
import { TextInputComponent } from './shared/form-input-components/text-input/text-input.component';
import { NumberInputComponent } from './shared/form-input-components/number-input/number-input.component';
import { TabsComponent } from './shared/components/tabs/tabs.component';
import { StepperComponent } from './shared/components/stepper/stepper.component';
import { DialogComponent } from './shared/components/dialog/dialog.component';
import { ToggleButtonComponent } from './shared/form-input-components/toggle-button/toggle-button.component';
import { RadioGroupComponent } from './shared/form-input-components/radio-group/radio-group.component';
import { RadioButtonComponent } from './shared/form-input-components/radio-group/radio-button/radio-button.component';
import { SelectComponent } from './shared/form-input-components/select/select.component';
import { DropdownComponent } from './shared/components/dropdown/dropdown.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { PopoverComponent } from './shared/components/popover/popover.component';
import { TimePickerComponent } from './shared/form-input-components/time-picker/time-picker.component';
import { DatePickerComponent } from './shared/form-input-components/date-picker/date-picker.component';
import { MisDatePickerModule, MisDateRangePickerConfig , MisDatePickerConfig} from 'mis-design-system/datepicker';
import { FieldGeneratorComponent } from './shared/form-input-components/field-generator/field-generator.component';
import { PaginationComponent } from './shared/pagination/pagination.component';

// Services
import { ApiService } from './shared/services/api.service';
import { AuthService } from './shared/services/auth.service';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { PermissionsGuardService } from './shared/services/permissions-guard.service';
import { StorageService } from './shared/services/storage.service';
import { ErrorNotificationService } from './shared/services/error-notification.service';
import { GlobalErrorHandler } from './shared/services/global-error-handler';
import { CommonService } from './shared/services/common.service';

// Directives
import { ClickOutsideDirective } from './shared/directives/click-outside.directive';

// Errors
import { ErrorComponent } from './error/error.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { SearchComponent } from './shared/components/search/search.component';
// tslint:disable-next-line: max-line-length
import { DateWiseBookingFormComponent } from './bookings/create-booking/trip-details/date-wise-booking-form/date-wise-booking-form.component';
// import { DateWiseBookingFormComponent as DateWiseBookingNewFormComponent} from './bookings-new/create-booking/trip-details/date-wise-booking-form/date-wise-booking-form.component';
import { CabFormComponent } from './bookings/create-booking/trip-details/cab-form/cab-form.component';
// import { CabFormComponent as CabFormNewComponent} from './bookings-new/create-booking/trip-details/cab-form/cab-form.component';
import { DateFormatterPipe } from './shared/pipes/date-formatter.pipe';
import { LocationSearchComponent } from './shared/form-input-components/location-search/location-search.component';
import { RiderNamePipe } from './shared/pipes/rider-name.pipe';
import { BookingDetailsComponent } from './bookings/shared/booking-details/booking-details.component';
import { RequesterDetailsComponent } from './bookings/shared/requester-details/requester-details.component';
import { UtilService } from './shared/services/util.service';
import { TimeFormatterPipe } from './shared/pipes/time-formatter.pipe';
import { MyBookingsCardComponent } from './bookings/my-bookings/my-bookings-card/my-bookings-card.component';
import { LoginComponent } from './auth/login/login.component';
import { DateTimeConverterPipe } from './shared/pipes/date-time-converter.pipe';
import { BooleanConverterPipe } from './shared/pipes/boolean-converter.pipe';
import { BookingsHistoryComponent } from './bookings/shared/bookings-history/bookings-history.component';
import { BookingActionsHeaderComponent } from './bookings/shared/booking-actions-header/booking-actions-header.component';
import { BookingsViewComponent } from './bookings/bookings-view/bookings-view.component';
// import { BookingsViewComponent as BookingViewNewComponent } from './bookings-new/bookings-view/bookings-view.component';
import { CheckboxComponent } from './shared/components/checkbox/checkbox.component';
import { BookingActionComponent } from './bookings/shared/booking-action/booking-action.component';
import { GarageMappingComponent } from './bookings/shared/garage-mapping/garage-mapping.component';
import { SendCommunicationComponent } from './bookings/shared/send-communication/send-communication.component';
import { DropdownCheckboxComponent } from './shared/form-input-components/dropdown-checkbox/dropdown-checkbox.component';
import { AddCabFormComponent } from './bookings/shared/add-cab-form/add-cab-form.component';
import { GeocodeComponent } from './bookings/shared/geocode/geocode.component';
import { PopoverSecondaryComponent } from './shared/components/popover-secondary/popover-secondary.component';
import { LandingPageComponent } from './core/landing-page/landing-page.component';
import { CabTrackComponent } from './bookings/shared/cab-track/cab-track.component';
import { MultipleCabTrackComponent } from './bookings/shared/multiple-cab-track/multiple-cab-track.component';
import { StatusCardsComponent } from './bookings/shared/status-cards/status-cards.component';
import { BillingReportsComponent } from './billing/billing-reports/billing-reports.component';
import { FileUploadComponent } from './billing/shared/file-upload/file-upload.component';
import { FileUploadInputComponent } from './billing/shared/file-upload-input/file-upload-input.component';
import { VendorSelectComponent } from './bookings/shared/vendor-select/vendor-select.component';
import { MapControlsComponent } from './shared/components/map-controls/map-controls.component';
import { InvoiceViewComponent } from './billing/invoice-view/invoice-view.component';
import { InvoiceEditComponent } from './billing/invoice-edit/invoice-edit.component';
import { ViewInvoiceComponent } from './bookings/shared/view-invoice/view-invoice.component';
import { InvoiceStatusComponent } from './billing/shared/invoice-status/invoice-status.component';
import { SendInvoiceComponent } from './billing/shared/send-invoice/send-invoice.component';
import { BookingDetailsPopoverComponent } from './bookings/shared/booking-details-popover/booking-details-popover.component';
import { RequestDetailsPopoverComponent } from './bookings/shared/request-details-popover/request-details-popover.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { BulkCreateComponent } from './bookings/bulk-create/bulk-create.component';
import { FileDragDropComponent } from './shared/components/file-drag-drop/file-drag-drop.component';
import { MergeBookingsComponent } from './bookings/shared/merge-bookings/merge-bookings.component';
import { SelectSectionedComponent } from './shared/form-input-components/select-sectioned/select-sectioned.component';
import { MergeBookingDetailsComponent } from './bookings/shared/merge-bookings/merge-booking-details/merge-booking-details.component';
import { MergeRiderDetailsComponent } from './bookings/shared/merge-bookings/merge-rider-details/merge-rider-details.component';
import { CancelBookingPopoverComponent } from './bookings/shared/cancel-booking-popover/cancel-booking-popover.component';
import { BulkcancelpopoverComponent } from './bookings/shared/bulkcancelpopover/bulkcancelpopover.component';
import { DateTimePickerComponent } from './shared/form-input-components/date-time-picker/date-time-picker.component';
import { PayeeDetailsComponent } from './bookings/shared/payee-details/payee-details.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotificationListComponent } from './shared/components/notification/notification.component';
import { NotificationService } from './shared/components/notification/notification.service';
import { CachedSrcDirective } from './shared/directives/iframe.directive';
import { HtppInterceptorService } from './http.interceptor';
import { ErrorInterceptor } from './error.interceptor';
import { IssueComponent } from './issue/issue.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { SessionManagementService } from './shared/services/session-management-service';
import { ViewDocumentComponent } from './billing/view-document/view-document.component';
import { SingleSelectComponent } from './billing/shared/single-select/single-select.component';
import { TableSkeletonComponent } from './shared/components/skeleton/table-skeleton/table-skeleton.component';
import { DropdownSkeletonComponent } from './shared/components/skeleton/dropdown-skeleton/dropdown-skeleton.component';
import { MultiselectComponent } from './shared/components/multiselect/multiselect.component';
import { MyBookingSkeletonComponent } from './shared/components/skeleton/my-booking-skeleton/my-booking-skeleton.component';
import { RaygunErrorHandler } from 'spotweb.raygun';
import { CommonBookingService } from './bookings/shared/common-booking.service';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {MatRippleModule} from '@angular/material/core';


import {MatDatepickerModule} from '@angular/material/datepicker';

import { HeaderNewComponent } from './core/header-new/header-new.component';
import { MatFormFieldControl } from '@angular/material/form-field';
import { SidebarNewComponent } from './core/sidebar-new/sidebar-new.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MisDatepickerComponent } from './shared/components/mis-datepicker/mis-datepicker.component';

import { ButtonModule } from "mis-crystal-design-system/button";
import { MisInputModule } from "mis-crystal-design-system/input";
import { ModalModule } from "mis-crystal-design-system/modal";
import { DrawerModule } from "mis-crystal-design-system/drawer";
import { ToastModule } from "mis-crystal-design-system/toast";
import { RadioButtonModule } from "mis-crystal-design-system/radio-button";
import { SwitchModule } from "mis-crystal-design-system/switch";
import { DropdownModule } from "mis-crystal-design-system/dropdown";
import { DatepickerModuleV2 } from "mis-crystal-design-system/datepicker_v2";
import { DateRangepickerModuleV2 } from "mis-crystal-design-system/daterangepicker_v2";
import { MultiSelectDropdownModule } from 'mis-crystal-design-system/multi-select-dropdown';
import {MatCardModule} from '@angular/material/card';
import { BookingDetailsSidebarComponent } from './bookings/my-bookings/my-bookings-card/booking-details-sidebar/booking-details-sidebar.component';
import {NgxPaginationModule} from 'ngx-pagination';
import { BookingSingleDetailsComponent } from './bookings/bookings-view/booking-single-details/booking-single-details.component';
import { InvoiceSingleDetailsComponent } from './billing/invoice-view/invoice-sigle-details/invoice-single-details.component';
import { HeaderNotificationComponent } from './core/header-notification/header-notification.component';
import { DatePipe } from '@angular/common';
import { PaymentCartComponent } from './bookings/my-bookings/payment-cart/payment-cart.component';
import { AvaComponent } from './bookings/ava/ava.component';
import { DbvaComponent } from './bookings/dbva/dbva.component';
import { CheckboxModule } from 'mis-crystal-design-system/checkbox';
import { PhoneInputModule } from "mis-crystal-design-system/phone-input";
import { ArraySlicePipe } from './shared/pipes/arraySlice.pipe';

import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { TimePreponePipe } from './shared/pipes/timePrepone';
import { TooltipListPipe } from './shared/pipes/tooltip-format.pipe';
// import { TimePickerComponent } from "../app/shared/form-input-components/time-picker/time-picker.component";
import { ToolTipModule } from "mis-crystal-design-system/tooltip";
import { OverlayModule } from '@angular/cdk/overlay';
import { TimepickerDirective } from '../app/shared/form-input-components/time-picker/time-picker.directive';
import { BookingInstructionComponent } from './shared/components/booking-instruction/booking-instruction.component';
import { ConfirmBookingDetailsComponent } from './bookings/shared/confirm-booking-details/confirm-booking-details.component';
import { AddOptionDropdownComponent } from './shared/components/add-option-dropdown/add-option-dropdown.component';
import { PhoneInputComponentComponent } from './shared/components/phone-input-component/phone-input-component.component';

import { DoubleSplitDropdownComponent } from './shared/components/double-split-dropdown/double-split-dropdown.component';
import {SpecificDatepickerModule} from "mis-crystal-design-system/specificdatepicker";
import { FormatPhoneNumberPipe } from './shared/pipes/format-phone-number.pipe';
import { EngagementCodeInputComponent } from './shared/form-input-components/engagement-code-input/engagement-code-input.component';
import { AppInitService } from './shared/services/app-init.service';
import { Observable } from 'rxjs';
import { NewRiderTableComponent } from './bookings/create-booking/user-details/new-rider-table/new-rider-table.component';
import {
  MatDialog,
  MatDialogRef,
  MatDialogActions,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogModule,
} from '@angular/material/dialog';
import { AddRiderComponent } from './bookings/create-booking/user-details/add-rider/add-rider.component';
import { TimeRangePickerComponent } from './shared/form-input-components/time-range-picker/time-range-picker.component';
import { DefineCabsDialogComponent } from './bookings/dbva/define-cabs-dialog/define-cabs-dialog.component';
import { TwelvehourtimeformatterPipe } from './shared/pipes/twelvehourtimeformatter.pipe';
import { RiderOtpViewComponent } from './bookings/shared/rider-otp-view/rider-otp-view.component';
import { RazorpayResolverService } from './shared/services/razorpay.resolver';
export function initializeApp(appInitService: AppInitService) {
  return (): Observable<any> => {
    return appInitService.init();
  };
}
@NgModule({
  declarations: [
    AppComponent,

    // Shared
    HeaderComponent,
    SidebarLinkComponent,
    ButtonComponent,
    TextInputComponent,
    NumberInputComponent,
    TabsComponent,
    StepperComponent,
    DialogComponent,
    ToggleButtonComponent,
    RadioGroupComponent,
    RadioButtonComponent,
    SelectComponent,
    DropdownComponent,
    ToastComponent,
    PopoverComponent,
    TimePickerComponent,
    ClickOutsideDirective,
    CachedSrcDirective,
    FieldGeneratorComponent,
    DatePickerComponent,
    PaginationComponent,
    MisDatepickerComponent,

    // style guide
    StyleGuideComponent,

    // bookings
    CreateBookingComponent,
    // CreateBookingNewComponent,
    MyBookingsComponent,
    RequestorFormComponent,
    // RequestorFormNewComponent,
    RidersTableComponent,
    // RidersTableNewComponent,
    UserDetailsComponent,
    // UserDetailsNewComponent,
    ConfirmRequestComponent,
    // ConfirmRequestNewComponent,
    TripDetailsComponent,
    // TripDetailsNewComponent,
    ErrorComponent,
    LoaderComponent,
    SearchComponent,
    DateWiseBookingFormComponent,
    // DateWiseBookingNewFormComponent,
    CabFormComponent,
    // CabFormNewComponent,
    DateFormatterPipe,
    LocationSearchComponent,
    RiderNamePipe,
    BookingDetailsComponent,
    RequesterDetailsComponent,
    TimeFormatterPipe,
    MyBookingsCardComponent,
    LoginComponent,
    DateTimeConverterPipe,
    BooleanConverterPipe,
    BookingsHistoryComponent,
    BookingActionsHeaderComponent,
    BookingsViewComponent,
    CheckboxComponent,
    BookingActionComponent,
    GarageMappingComponent,
    SendCommunicationComponent,
    DropdownCheckboxComponent,
    AddCabFormComponent,
    GeocodeComponent,
    PopoverSecondaryComponent,
    LandingPageComponent,
    CabTrackComponent,
    MultipleCabTrackComponent,
    StatusCardsComponent,
    BillingReportsComponent,
    FileUploadComponent,
    FileUploadInputComponent,
    VendorSelectComponent,
    MapControlsComponent,
    InvoiceViewComponent,
    InvoiceEditComponent,
    ViewInvoiceComponent,
    InvoiceStatusComponent,
    SendInvoiceComponent,
    BookingDetailsPopoverComponent,
    RequestDetailsPopoverComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    BookingDetailsPopoverComponent,
    RequestDetailsPopoverComponent,
    MergeBookingsComponent,
    SelectSectionedComponent,
    MergeBookingDetailsComponent,
    MergeRiderDetailsComponent,
   
    BulkCreateComponent,
    FileDragDropComponent,
    CancelBookingPopoverComponent,
    BulkcancelpopoverComponent,
    DateTimePickerComponent,
    PayeeDetailsComponent,
    NotificationListComponent,
    IssueComponent,
    ViewDocumentComponent,
    SingleSelectComponent,
   
    TableSkeletonComponent,
    DropdownSkeletonComponent,
    MultiselectComponent,
    MyBookingSkeletonComponent,
    HeaderNewComponent,
    // BookingViewNewComponent,
    SidebarNewComponent,
    MisDatepickerComponent,
    BookingDetailsSidebarComponent,
    BookingSingleDetailsComponent,
    InvoiceSingleDetailsComponent,
    HeaderNotificationComponent,
    PaymentCartComponent,
    AvaComponent,
    DbvaComponent,
    ArraySlicePipe,
    TimePreponePipe,
    TooltipListPipe,
    TimepickerDirective,
    BookingInstructionComponent,
    ConfirmBookingDetailsComponent,
    AddOptionDropdownComponent,
    DoubleSplitDropdownComponent,
    PhoneInputComponentComponent,
    FormatPhoneNumberPipe,
    EngagementCodeInputComponent,
    NewRiderTableComponent,
    AddRiderComponent,
    TimeRangePickerComponent,
    DefineCabsDialogComponent,
    TwelvehourtimeformatterPipe,
    RiderOtpViewComponent,
   
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    // MbscModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatFormFieldModule,
    NgIdleKeepaliveModule.forRoot(),
    MatStepperModule,
    MatTableModule,
    MatSortModule,
    MatRippleModule,
    MatSidenavModule,
    MatListModule,
    ButtonModule,
    MisInputModule,
    RadioButtonModule,
    MatTooltipModule,
    SwitchModule,
    ModalModule.forRoot(),
    DrawerModule.forRoot(),
    ToastModule.forRoot(),
    DropdownModule,
    DatepickerModuleV2,
    DateRangepickerModuleV2,
    MultiSelectDropdownModule,
    MatCardModule,
    NgxPaginationModule,
    MisDatePickerModule.forRoot(),
    CheckboxModule,
    PhoneInputModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    ToolTipModule,
    OverlayModule,
    SpecificDatepickerModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  providers: [
    RazorpayResolverService,
    MisDatePickerConfig,
    MisDateRangePickerConfig,
    ApiService,
    CreateBookingService,
    MyBookingsService,
    ErrorNotificationService,
    CommonService,
    AuthService,
    AuthGuardService,
    PermissionsGuardService,
    StorageService,
    NotificationService,
    SessionManagementService,
    UtilService,
    CommonBookingService,
    AppInitService,
    FormatPhoneNumberPipe,
    TwelvehourtimeformatterPipe,
    { provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HtppInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    { provide: ErrorHandler, useClass: RaygunErrorHandler },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
    DatePipe
  ],
  exports: [ ClickOutsideDirective ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
declare module "@angular/core" {
  interface ModuleWithProviders<T = any> {
      ngModule: Type<T>;
      providers?: Provider[];
  }
}
